/* eslint-disable arrow-parens */
const formAssessment = document.getElementById('assessment-form');
const allInput = formAssessment ? formAssessment.querySelectorAll('input') : null;
const allNameInputs = [];

function formSuccsess(form) {
	form.innerHTML = '';
	const html = `<div class="popup-registration__success">
					<div class="popup-registration__success-icon">
						<svg>
							<use xlink:href="/images/sprites.svg#icon-check-white"></use>
						</svg>
					</div>
					Голос принят
					<span>
						Спасибо за&nbsp;участие в&nbsp;голосовании. Ознакомьтесь с&nbsp;другими проектами в&nbsp;разных номинациях
					</span>
					<a class="btn btn--oval btn--green" href="/lichnyj-kabinet-expert ">В личный кабинет</a>
				</div>`;
	formAssessment.innerHTML = html;
}

function resetValue() {
	allInput.forEach(el => {
		if (el.name !== 'usage') {
			el.checked = false;
		}
	});
}

function showEstimates(show) {
	const estimates = formAssessment.querySelector('.lichnyj-kabinet__assessment-form-estimates');

	if (show) {
		const height = estimates.querySelector('.lichnyj-kabinet__assessment-form-estimates-wrapper').getBoundingClientRect().height;
		estimates.style.height = `${height}px`;
	} else {
		estimates.style.height = '0px';
	}
}

function checkUsage(e) {
	const submitBtn = formAssessment.querySelector('.form__submit');

	if (e.target.id === 'no') {
		resetValue();
		submitBtn.disabled = false;
		showEstimates(false);
	} else {
		submitBtn.disabled = true;
		showEstimates(true);
	}
}

function checkEstimates() {
	let counter = 0;

	allNameInputs.forEach(name => {
		for (let i = 0; i < allInput.length; i++) {
			if (allInput[i].name === name && allInput[i].checked) {
				counter += 1;
				break;
			}
		}
	});

	if (counter === allNameInputs.length) {
		formAssessment.querySelector('.form__submit').disabled = false;
	} else {
		formAssessment.querySelector('.form__submit').disabled = true;
	}
}

function init() {
	if (formAssessment) {
		allInput.forEach(el => {
			if (!allNameInputs.includes(el.name)) {
				allNameInputs.push(el.name);
			}
			el.addEventListener('change', e => {
				checkEstimates();
				if (e.target.name === 'usage') {
					checkUsage(e);
				}
			});
		});
	}
}

export default {
	init,
	formSuccsess,
};
